import styled from 'styled-components';

export const CollapseContainer = styled.div`
  width: -webkit-fill-available;
`;

export const CollapseTitle = styled.label`
  font-size: larger;
  font-weight: 500;
`;

export const CollapseIconContainer = styled.label`
  cursor: pointer;
`;

export const CollapseHeader = styled.div<{
  isOpen: boolean;
}>`
  display: flex;
  background-color: rgb(167, 167, 167);
  border: 1px solid #cecece;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: ${({ isOpen }) => (isOpen ? '0' : '10px')};
  border-bottom-right-radius: ${({ isOpen }) => (isOpen ? '0' : '10px')};
  padding: 12px;
  align-items: center;
  justify-content: space-between;
`;

export const CollapseContent = styled.div<{
  isOpen: boolean;
  height: number;
  transition: number;
}>`
  display: block;
  background-color: rgb(236, 236, 236);
  transition: height ${({ transition }) => `${transition}ms`} ease;
  height: ${({ isOpen, height }) => (isOpen ? `${height}px` : '0')};
  overflow: hidden;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom: ${({ isOpen }) => (isOpen ? '1px' : '0')} solid #cecece;
  border-left: ${({ isOpen }) => (isOpen ? '1px' : '0')} solid #cecece;
  border-right: ${({ isOpen }) => (isOpen ? '1px' : '0')} solid #cecece;
`;
